import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/valuesForFilter`;

export const ROUTE: RouteDefinition = `${baseRoute}/valuesForFilter`;

export const URL = (): RouteDefinition => `${baseRoute}/valuesForFilter`;
